import React, { useState } from 'react';
import { useApiClient, useFetchImmutable } from '@marageti/z4-lib';
import { CountryCodeMap } from '@marageti/z4-sdk/lib/standards';
import { EditTravelerPersonalDetailsForm } from '../modals/edit-traveler-personal-details-form';
import useTravelerProfile from '../../hooks/use-traveler-profile';
import TravelerPersonalDetailsCard from './traveler-personal-details-card';

type TravelerPersonalDetailsContainerProps = {
  travelerId: string | undefined;
  canEdit: boolean;
};

const TravelerPersonalDetailsContainer = ({
  travelerId,
  canEdit,
}: TravelerPersonalDetailsContainerProps) => {
  const apiClient = useApiClient();
  const { travelerProfile, updateTravelerProfile } = useTravelerProfile(travelerId);
  const { data: countryCodes } = useFetchImmutable<CountryCodeMap>(apiClient.standardsClient.getCountryCodes, [], true);
  const [isEditOpen, setIsEditOpen] = useState(false);

  return (
    <>
      <TravelerPersonalDetailsCard
        onEditClick={canEdit ? () => setIsEditOpen(true) : undefined}
        personalDetails={travelerProfile?.personalDetails}
        countryCodes={countryCodes}
      />
      {travelerProfile && (
        <EditTravelerPersonalDetailsForm
          open={isEditOpen}
          onClose={() => setIsEditOpen(false)}
          travelerProfile={travelerProfile}
          updateTravelerProfile={updateTravelerProfile}
        />
      )}
    </>
  );
};

export default TravelerPersonalDetailsContainer;
